import React, { useState, useMemo } from "react";
import { PageHeader } from "@finitless/shared/components";
import { useTranslation } from "react-i18next";
import { IMPORTER_CARDS, MenuImporterCard } from "../../ui/MenuImporters";
import { IntegrationFilters } from "../../ui";

/**
 * Menu Importers page — grid of importer cards (DoorDash, Uber Eats, etc.).
 * Reuses IntegrationFilters, PageHeader; pattern from SalesChannelsPage.
 */
const MenuImportersPage = ({ selectedBrand }) => {
  const { t } = useTranslation("menuImporters");
  const [searchTerm, setSearchTerm] = useState("");

  const filteredCards = useMemo(() => {
    if (!searchTerm.trim()) return IMPORTER_CARDS;
    const lower = searchTerm.toLowerCase().trim();
    return IMPORTER_CARDS.filter((card) =>
      card.searchTerms.some((term) => term.toLowerCase().includes(lower)),
    );
  }, [searchTerm]);

  const handleSearchChange = (value) => {
    setSearchTerm(value);
  };

  return (
    <div>
      <PageHeader
        title={t("page.title")}
        subtitle={t("page.subtitle")}
        selectedBrand={selectedBrand}
      />

      <IntegrationFilters
        searchTerm={searchTerm}
        onSearchChange={handleSearchChange}
        placeholder={t("searchPlaceholder")}
      />

      <div className="mt-6">
        {filteredCards.length === 0 ? (
          <div className="py-12 text-center">
            <div className="mx-auto mb-4 flex h-24 w-24 items-center justify-center rounded-full bg-gray-800">
              <svg
                className="h-12 w-12 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                />
              </svg>
            </div>
            <h3 className="mb-2 text-lg font-medium text-white">
              {searchTerm ? t("empty.searchTitle") : t("empty.defaultTitle")}
            </h3>
            <p className="text-gray-400">
              {searchTerm
                ? t("empty.searchDescription", { searchTerm })
                : t("empty.comingSoonPlatforms")}
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
            {filteredCards.map((card) => (
              <MenuImporterCard key={card.id} {...card} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MenuImportersPage;
